import React from 'react';
import styles from './IdentityGate.module.css';

const IdentityGate = ({ 
    isMember, 
    isRevealing, 
    email, 
    setEmail, 
    emailError, 
    setEmailError, 
    isSubmitting, 
    handleUnlock,
    isSyncing = false
}) => {
    if (isMember) return null;
    

    return (
        <div className={`${styles['identity-gate']} ${isRevealing ? styles['gate-exit'] : ''}`} style={{ zIndex: 100 }}>
            <div className={styles['gate-card']}>
                <h3>Unlock the Forensic Audit</h3>
                <p>Enter your email to see the full breakdown and live value shifts.</p>
                <form
                    className={styles['gate-form']}
                    onSubmit={handleUnlock}
                >
                    <input
                        type="email"
                        placeholder={email || "Enter Email"}
                        className={styles['gate-input']}
                        value={email}
                        onChange={(e) => { setEmail(e.target.value); setEmailError(''); }}
                        disabled={isSubmitting}
                        required
                    />
                    {emailError && (
                        <p style={{ color: '#ef4444', fontSize: '12px', margin: '4px 0 0', textAlign: 'left' }}>
                            {emailError}
                        </p>
                    )}
                    <button
                        type="submit"
                        className={styles['gate-button']}
                        disabled={isSubmitting}
                        style={{ opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
                    >
                        {isSubmitting ? 'Please wait…' : 'Get Elite Access'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default IdentityGate;
